import { SlotGameType1_2 } from "../SlotGameType1_2";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SlideFactory } from "../Slider/SecondScreenHelp"
import { SetStyles } from "../.././MyHelpers";

// namespace SlotGames2
// {
	export class PandaQuest2 extends SlotGameType1_2
	{
		
		protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
		{
			super.PaytableLoaded(resourceManager);
			SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
			{
				//HIDE BACKGROUND
				//backgroundColor:"rgba(0, 0, 0, 0.6)",
			});
		}

		// protected PrepareFonts(resourceManager: ResourceManager): void 
		// {
		// 		resourceManager.Add(new FontResource(this.basepath + "resources/go3v2.ttf", "." + this.resid.ScopedResourceName(["font"])));
		// }
	
	}

	class PandaQuestSecondScreenHelpFactory extends SlideFactory
	{
		public override CreateStyle():Partial<CSSStyleDeclaration>
		{
			let style: Partial<CSSStyleDeclaration> = 
			{
				color:"White"
			};
			return style;
		}
	}

// }
